import { BillingInterval } from "shared/enums/BillingIntervalEnum";

interface Props {
  billingInterval: BillingInterval;
}

export default function BillingIntervalDisplay(props: Props) {
  const { billingInterval } = props;

  const getBillingIntervalText = () => {
    let text = "once";
    if (billingInterval === BillingInterval.Monthly) {
      text = "per month";
    } else if (billingInterval === BillingInterval.Yearly) {
      text = "per year";
    }
    return text;
  };

  return <span>{getBillingIntervalText()}</span>;
}
